var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubstituirNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12502 10.4999V3.36851L3.85007 5.64347L2.62511 4.37495L7 0L11.3749 4.37495L10.1499 5.64347L7.87498 3.36851V10.4999H6.12502ZM1.75013 13.9998C1.51994 14.0031 1.29153 13.9591 1.07897 13.8707C0.866421 13.7823 0.67423 13.6513 0.514264 13.4857C0.348711 13.3258 0.217684 13.1336 0.129265 12.921C0.040846 12.7084 -0.00308592 12.48 0.000168448 12.2499V9.62489H1.75013V12.2499H12.2499V9.62489H13.9998V12.2499C14.0031 12.48 13.9592 12.7084 13.8707 12.921C13.7823 13.1336 13.6513 13.3258 13.4857 13.4857C13.3258 13.6513 13.1336 13.7823 12.921 13.8707C12.7085 13.9591 12.4801 14.0031 12.2499 13.9998H1.75013Z",
    fill: "#22638D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstituirNew);
export default __webpack_public_path__ + "static/media/substituir_new.049ffa876ee46a9b7107fe5363cec991.svg";
export { ForwardRef as ReactComponent };